import { Badge, Group } from '@mantine/core';
import React from 'react';
import { useOverflowList } from 'src/design/molecules/useOverflowList';
import { DisclosurePopover } from 'src/design/molecules/DisclosurePopover';

export interface IBadgeShortListProps {
  items: React.ReactNode[];
  maxItems?: number;
}

/** @registry Inline badges/nodes capped at `maxItems` with a "+N" overflow, revealed via a keyboard-accessible disclosure; use for compact lists of tags/roles/etc. */
export const BadgeShortList = React.memo<IBadgeShortListProps>(
  ({ items, maxItems = 2 }) => {
    const { visible, hidden, remaining, overflowLabel } = useOverflowList(
      items,
      maxItems,
    );

    return (
      <Group gap="xs" wrap="wrap">
        {visible.map((item) => item)}
        {remaining > 0 && (
          <DisclosurePopover
            label={overflowLabel}
            content={
              <Group gap="xs" wrap="wrap" maw={450}>
                {hidden.map((item) => item)}
              </Group>
            }
          >
            <Badge
              component="button"
              type="button"
              color="gray"
              variant="light"
              style={{ cursor: 'pointer' }}
            >
              {`+${remaining}`}
            </Badge>
          </DisclosurePopover>
        )}
      </Group>
    );
  },
);
